import { render, staticRenderFns } from "./CompareItem.vue?vue&type=template&id=7750815e&"
import script from "./CompareItem.vue?vue&type=script&lang=js&"
export * from "./CompareItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports